export const FORMA_PAGAMENTO_PRE = 0
export const FORMA_PAGAMENTO_POS = 1
export const FormasPagamento = {
    [FORMA_PAGAMENTO_PRE]: {title: 'Pré-pago'},
    [FORMA_PAGAMENTO_POS]: {title: 'Pós-pago'}
}
